// extracted by mini-css-extract-plugin
export default {"container":"Main_container__d1NS+","container__content":"Main_container__content__JxwXw","container__marginBottom":"Main_container__marginBottom__9YC3-"};